
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Body1 } from '@fluentui/react-components';

import { I18nContext } from '@bingads-webui-react/i18n-context';
import { PropertyRow } from '@bingads-webui-campaign-react/ui-generator';

export const AdCount = ({ numAds }) => {
  const i18n = useContext(I18nContext);

  return (
    <PropertyRow propertyLabel={{ label: _TL_('Number of Ads') }}>
      <Body1 block>{`${numAds} ${i18n.getString(numAds === 1 ? _TL_('Ad') : _TL_('Ads'))}`}</Body1>
    </PropertyRow>
  );
};

AdCount.propTypes = {
  numAds: PropTypes.number.isRequired,
};

